import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const AppConfigsServiceContext = createContext(undefined)

const AppConfigsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={AppConfigsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        getMe: async () => {
          const {data} = await axios.get(`/api/v1/core/app_configs/me`)
          return data
        },
        updateMe: async (payload) => {
          const {data} = await axios.patch(`/api/v1/core/app_configs/me`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

AppConfigsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useAppConfigsService = () => {
  const context = useContext(AppConfigsServiceContext)
  if (context === undefined) {
    throw new Error('AppConfigsServiceContext was not provided. Make sure your component is a child of the AppConfigsServiceProvider.')
  }
  return context
}

const useAppConfigQuery = (props) => {
  const appConfigsService = useAppConfigsService()
  return useSimpleQuery({
    queryKey: `app_configs-get-me`,
    queryFn: async () => appConfigsService.getMe(),
    ...props
  })
}

export {AppConfigsServiceProvider, useAppConfigsService, useAppConfigQuery}
